import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAspectRatioComponent } from "./med-icon-aspect-ratio.component";

@NgModule({
  declarations: [
    MedIconAspectRatioComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAspectRatioComponent,
  ],
})
export class MedIconAspectRatioModule { }
